import { mediaItems, aboutInfo, topicItems, faqItems } from '@/mocks/home';

export function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">精彩看点</h2>
          <p className="text-foreground-600 max-w-[600px] mx-auto">热门预告与幕后花絮，提前感受影片魅力</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-200 cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-500 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/70 text-white text-xs px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-800 mb-1 line-clamp-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{item.channel}</span>
                  <span className="text-xs text-foreground-500">{item.description.length > 15 ? `${item.description.slice(0, 15)}...` : item.description}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">{aboutInfo.title}</h2>
          <p className="text-foreground-600 leading-relaxed mb-5">{aboutInfo.description1}</p>
          <p className="text-foreground-600 leading-relaxed">{aboutInfo.description2}</p>
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">热门话题</h2>
          <p className="text-foreground-600 max-w-[600px] mx-auto">全网影迷都在讨论的影视话题，加入讨论发现更多好片</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-[900px] mx-auto">
          {topicItems.map((item, i) => (
            <div
              key={i}
              className="group flex items-center gap-2.5 bg-background-50 hover:bg-accent-50 rounded-full px-5 py-3 cursor-pointer transition-all duration-200 border border-background-200 hover:border-accent-300"
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 flex-shrink-0">
                <i className={`${item.icon} text-sm`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-accent-700 transition-colors whitespace-nowrap">{item.name}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">常见问题</h2>
          <p className="text-foreground-600 max-w-[600px] mx-auto">关于麻花影视，你可能想了解的事情</p>
        </div>
        <div className="max-w-[800px] mx-auto space-y-4">
          {faqItems.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-3">{item.question}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}